// extracted by mini-css-extract-plugin
export default {"item":"IconGridLink-module--item--d7c08","icon":"IconGridLink-module--icon--b360e"};